//index.js
import Tab from './Tab';
import Tabs from './Tabs';

export { Tab, Tabs };
